import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import { ReputationRank, TopRanking } from "./components/Rankings";
import { CategoryPreview } from "./components/CategoryPreview";
import FaqSection from "./components/FaqSection";

const faqJson = [
  {
    q: "小虎看番的片单是怎么整理出来的？",
    a: "综合评分热度、观众讨论与弹幕口碑，加上多年补番经验，把值得看的好番按高分、冷门、完结、熬夜四大主题分类整理。",
  },
  {
    q: "片单里的评分是哪里来的？",
    a: "评分综合了主流平台的观众评分与口碑反馈，并人工标注封神、神作、名场面等标签，仅供参考。",
  },
  {
    q: "冷门佳作和口碑番有什么区别？",
    a: "口碑番是热度高、讨论多的作品；冷门佳作则评分同样出色、但被多数人忽略的宝藏，小虎两边都在挖。",
  },
  {
    q: "番剧片单会定期更新吗？",
    a: "高分番排行榜、冷门佳作和完结番合集每周五更新，熬夜补番清单随新番动态调整。",
  },
];

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "小虎看番",
      url: "https://lntsbz.cn/",
      description:
        "小虎看番是专注补番推荐的动画片单站，提供高分番列表、冷门佳作、完结番合集与熬夜补番清单。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "小虎看番",
      description: "告别剧荒的动画补番推荐站",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqJson.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="小虎看番 | 补番推荐：高分番列表与冷门佳作合集"
        description="不知道补什么？小虎看番为你整理高分番列表、冷门佳作与口碑番排行，还有完结番合集和熬夜补番清单，点开就能找到合口味的片单，告别剧荒。"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <TopRanking />
        <ReputationRank />
        <CategoryPreview />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}